import {
  GenericMutationResult,
  ModelProgramMembershipConnection,
  ProgramMembership,
  ProgramsByUserQuery,
  UpdateProgramMembershipsInput,
  UpdateProgramMembershipsMutation,
  UpdateProgramMembershipsMutationVariables
} from "../../API";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { genericQuery, listQueryAutoPaginated } from "../api/apiUtils";
import { API } from "aws-amplify";

export async function fetchMembershipsByUserId(userId: string) {
  const predicate = { programMemberId: userId };
  // Need to call the custom query ListProgramMembershipsByUserId here, or else
  //  the ProgramMembershipDeletion bug reappears (all other Memberships in the
  //  table are deleted upon insert).  Should address the bug in membershipUtils to
  //  avoid this going forward.
  return await listQueryAutoPaginated<
    ProgramsByUserQuery,
    ProgramMembership,
    ModelProgramMembershipConnection
  >(queries.programsByUser, "programsByUser", "items", predicate);
}

export async function updateProgramMemberships(
  input: UpdateProgramMembershipsInput
): Promise<GenericMutationResult | null> {
  const path = `user/${input.userId}/program-memberships`;
  
  const response = await API.put("simpl-api", path, {
    body: {
      userId: input.userId,
      programMemberships: input.programMemberships
    }
  });
  
  // Response format: { success: true, message: "..." } or { success: false, error: "..." }
  const result: GenericMutationResult = {
    __typename: "GenericMutationResult",
    success: response.success,
    message: response.message || null,
    error: response.error || null
  };
  
  if (!response.success) {
    throw new Error(response.error || "Failed to update program memberships");
  }
  
  return result;
}
